export { SUPPORTED_IMAGE_MIME_TYPES } from '@scale/mm-shared';
import { ModelInputFileAttachmentType } from '@scale/shared/types/chat';

export type PromptGenerationModelId = 'goldfish' | 'llama-3.1-70b' | 'gpt-4o';

export const PROMPT_GENERATION: {
  USER_INPUT: string;
  MODELS: {
    id: PromptGenerationModelId;
    name: string;
    params: Record<string, any>;
    url: string;
  }[];
} = {
  USER_INPUT: 'Generate prompts according to the system prompt and conversation history.',
  MODELS: [
    {
      id: 'goldfish',
      name: 'Goldfish (research-grok-lc-1017)',
      params: {
        model: 'research-grok-lc-1017',
        max_tokens: 16000,
        use_case: 'sft/rlhf',
        partial_gen: 'chat_with_files',
      },
      url: 'https://api.x.ai',
    },
    {
      id: 'goldfish',
      name: 'Goldfish (research-grok-lc-1030)',
      params: {
        model: 'research-grok-lc-1030',
        max_tokens: 16000,
        use_case: 'sft/rlhf',
        partial_gen: 'chat_with_files',
      },
      url: 'https://api.x.ai',
    },
    {
      id: 'llama-3.1-70b',
      name: 'Llama 3.1 70B',
      params: {
        model: 'llama-3-1-70b-instruct',
      },
      url: 'https://api.egp.scale.com/v2/chat-completions',
    },
    {
      id: 'gpt-4o',
      name: 'gpt-4o',
      params: {
        model: 'gpt-4o',
      },
      url: 'https://api.openai.com/v1/chat/completions',
    },
  ],
};

export const FILE_ATTACHMENTS_MAX_ATTACHMENTS = 5;
export const FILE_ATTACHMENTS_ALLOWED_MIME_TYPES_BY_INPUT_TYPE: Record<
  ModelInputFileAttachmentType,
  string[]
> = {
  [ModelInputFileAttachmentType.Text]: ['text/*'],
  [ModelInputFileAttachmentType.Json]: ['application/json'],
  [ModelInputFileAttachmentType.Pdf]: ['application/pdf'],
  [ModelInputFileAttachmentType.Image]: ['image/*'],
  [ModelInputFileAttachmentType.Audio]: ['audio/*'],
  [ModelInputFileAttachmentType.Document]: ['application/pdf'],
  [ModelInputFileAttachmentType.Zip]: ['application/zip'],
  [ModelInputFileAttachmentType.Video]: ['video/*'],
  [ModelInputFileAttachmentType.Other]: ['*/*'],
};
